import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { MainLayoutComponent } from '@app/layout/main-layout/main-layout.component';
import { ListComponent } from './list/list.component';
import { DetailsComponent } from './details/details.component';
import { DetailsResolver } from './details-resolver';
import { NotificationComponent } from '@app/_shared/notification/notification.component';
import { CertificationComponent } from '@app/_shared/certification/certification.component';
import { ScheduleComponent } from '@app/_shared/schedule/schedule.component';
import { NewComponent } from './new/new.component';
import { HistoryComponent } from './history/history.component';
import { ResultComponent } from './result/result.component';
import { ExecHistoryComponent } from './exec-history/exec-history.component';
import { MastersuiteAssociateComponent } from './mastersuite-associate/mastersuite-associate.component';
import { UnsavedChangesGuard } from '@app/_guards/unsavedChanges.guard';

const routes: Routes = [
    { path: '', component: ListComponent },
    { path: 'new', component: NewComponent },
    { path: ':id', component: DetailsComponent, resolve: { details: DetailsResolver } },
    { path: ':id/edit', component: NewComponent, resolve: { details: DetailsResolver } },
    { path: ':id/notification', component: NotificationComponent, resolve: { details: DetailsResolver }, data: { type: 'MASTERSUITE' }, canDeactivate: [UnsavedChangesGuard] },
    { path: ':id/certification', component: CertificationComponent, resolve: { details: DetailsResolver }, data: { type: 'MASTERSUITE' } },
    { path: ':id/associate', component: MastersuiteAssociateComponent, resolve: { details: DetailsResolver }, data: { type: 'MASTERSUITE' } },
    { path: ':id/history', component: HistoryComponent, resolve: { details: DetailsResolver } },
    { path: ':id/result', component: ResultComponent, resolve: { details: DetailsResolver } },
    { path: ':id/schedule', component: ScheduleComponent, resolve: { details: DetailsResolver }, data: { type: 'MASTERSUITE' } },
    { path: ':id/execution-history', component: ExecHistoryComponent, resolve: { details: DetailsResolver } }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class MastersuiteRoutingModule { }